var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.title ? _c("label", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-group" },
      [
        _c("DatePicker", {
          attrs: {
            disabled: _vm.disabled,
            type: "date",
            format: "DD-MM-YYYY",
            valueType: _vm.format,
            placeholder: _vm.placeholder,
          },
          model: {
            value: _vm.selectedValue,
            callback: function ($$v) {
              _vm.selectedValue = $$v
            },
            expression: "selectedValue",
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "invalid-feedback",
            class: { "d-block": _vm.hasErrors },
            attrs: { role: "alert" },
          },
          [_c("strong", [_vm._v(_vm._s(_vm.errors[0]))])]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }